import React from 'react';

interface BoltBadgeProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'light' | 'dark';
}

const BoltBadge: React.FC<BoltBadgeProps> = ({ 
  className = '', 
  size = 'medium',
  variant = 'dark'
}) => {
  const sizeClasses = {
    small: 'text-xs px-2 py-1',
    medium: 'text-sm px-3 py-1.5',
    large: 'text-base px-4 py-2'
  };

  const variantClasses = {
    light: 'bg-white text-black hover:bg-gray-100',
    dark: 'bg-black text-white hover:bg-gray-800'
  };

  const iconSize = {
    small: 12,
    medium: 16,
    large: 20
  };

  return (
    <a 
      href="https://bolt.new" 
      target="_blank" 
      rel="noopener noreferrer"
      className={`flex items-center gap-2 ${sizeClasses[size]} ${variantClasses[variant]} rounded-lg font-medium transition-colors ${className}`}
    >
      <svg width={iconSize[size]} height={iconSize[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L4 6V18L12 22L20 18V6L12 2Z" fill={variant === 'light' ? '#3B82F6' : '#3B82F6'}/>
        <path d="M12 2L4 6V18L12 22V2Z" fill={variant === 'light' ? '#2563EB' : '#2563EB'}/>
        <path d="M12 2L20 6V18L12 22V2Z" fill={variant === 'light' ? '#60A5FA' : '#60A5FA'}/>
      </svg>
      Built with Bolt.new
    </a>
  );
};

export default BoltBadge;